<template>
  <div class="deposit-container">
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      top="5vh"
    >
      <el-tabs>
        <el-tab-pane :label="`Deposit ${ currency && currency.toUpperCase() }`">
          <el-form
            :model="depositForm"
            id="depositForm"
            ref="depositForm"
            label-width="150px"
            size="small"
            :rules="depositFormRules"
            :label-position="device === 'mobile' ? 'top' : 'right'"
          >
            <el-form-item label="Action" prop="action">
              <el-select v-model="depositForm.action">
                <el-option label="Debit" value="debit"></el-option>
                <el-option label="Credit" value="credit"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Amount" prop="amount">
              <el-input
                type="number"
                v-model="depositForm.amount"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item label="Reason" prop="reason">
              <el-input v-model="depositForm.reason"></el-input>
            </el-form-item>

                        
            <el-form-item label="Crediting Note" prop="creditingNote">
              <el-select v-model="depositForm.creditingNote" placeholder="Please select note">
                <el-option label="Internal Prefund/Liquidity Transfer" value="Internal Prefund/Liquidity Transfer"></el-option>
                <el-option label="Internal Commission Transfer" value="Internal Commission Transfer"></el-option>
                <el-option label="Customer Order Payment" value="Customer Order Payment"></el-option>
                <el-option label="Reconciliation accounting" value="Reconciliation accounting"></el-option>
                <el-option label="Clear Balance for closing account" value="Clear Balance for closing account"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button
                :loading="submitingDeposit"
                type="primary"
                @click="submitDeposit()"
                >Submit</el-button
              >
              <el-button @click="dialogVisible = false">Cancel</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane :label="`Topup ${ currency && currency.toUpperCase() } (Test)`" v-if="superRole">
          <el-form
            :model="topupForm"
            id="topupForm"
            ref="topupForm"
            label-width="150px"
            size="small"
            :rules="topupFormRules"
            :label-position="device === 'mobile' ? 'top' : 'right'"
          >
            <el-form-item label="Currency" prop="currency">
              <el-select v-model="topupForm.currency">
                <el-option label="GBP" value="GBP"></el-option>
                <el-option label="EUR" value="EUR"></el-option>
                <el-option label="USD" value="USD"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Amount" prop="amount">
              <el-input
                type="number"
                v-model="topupForm.amount"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                :loading="submitingTopup"
                type="primary"
                @click="submitTopup()"
                >Submit</el-button
              >
              <el-button @click="dialogVisible = false">Cancel</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { topupBankAccount, depositBankAccount } from "@/api/bank-account";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    superRole(){
      return this.roleAuth([this.role.spadmin])
    }
  },
  data() {
    return {
      dialogVisible: false,
      submitingTopup: false,
      submitingDeposit: false,
      currency: "",
      topupForm: {
        bankholderID: "",
        currency: "",
        amount: 0,
      },
      depositForm: {
        action: "debit",
        reason: "",
        amount: 0,
        creditingNote: ""
      },
      topupFormRules: {
        currency: [
          {
            required: true,
            message: "Please select Currency",
            trigger: "change",
          },
        ],
        amount: [
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          },
          {
            min: 1,
            message: "Please enter Amount",
            trigger: "blur",
          },
        ],
      },
      depositFormRules:{
        amount: [
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          },
          {
            min: 1,
            message: "Please enter Amount",
            trigger: "blur",
          },
        ],
        creditingNote: [
          {
            required: true,
            message: "Please select note",
            trigger: "blur",
          },
        ]
      }
    };
  },
  methods: {
    showDepositTopup(bankholderID = "0000001", currency) {
      
      this.submitingTopup = false
      this.submitingDeposit = false
      this.dialogVisible = true;
      this.topupForm.bankholderID = bankholderID;
      this.topupForm.amount = 0;
      this.topupForm.currency = currency ? currency.toUpperCase() : "GBP";

      this.depositForm.action = "debit";
      this.depositForm.reason = "";
      this.depositForm.amount = 0;
      this.depositForm.creditingNote = "";
   
      this.currency = currency
    },
    submitTopup() {
      this.$refs.topupForm.validate((valid) => {
        if (valid) {
          this.submitingTopup = true;
          topupBankAccount(this.topupForm.bankholderID, this.topupForm).then(
            ({ result, data }) => {
              this.submitingTopup = false;
              if (result) {
                this.$notify({
                  title: "Success",
                  message: `Topup ${this.topupForm.currency} ${this.topupForm.amount} Bank account successfully`,
                  type: "success",
                  duration: 2000
                });
                this.dialogVisible = false;
                this.$emit("submited");
              }
            }
          );
        }
      });
    },
    submitDeposit(){
      this.$refs.depositForm.validate((valid) => {
        if (valid) {
          this.submitingDeposit = true;
          depositBankAccount(this.topupForm.bankholderID, this.depositForm).then(
            ({ result, data }) => {
              this.submitingDeposit = false;
              if (result) {
                this.$notify({
                  title: "Success",
                  message: `Deposit successfully`,
                  type: "success",
                  duration: 2000
                });
                this.dialogVisible = false;
                this.$emit("submited");
              }
            }
          );
        }
      })
    }
  }
};
</script>

<style lang="scss">
.deposit-container {
  .el-dialog__body {
    padding: 10px;
  }
  .el-tab-pane {
    padding: 20px;
  }
}
</style>